/* eslint-disable */
import React, { useState, useEffect } from 'react'; // eslint-disable-next-line
import './main.css';
import { Link } from 'react-router-dom';
import { Modal } from 'react-bootstrap';
import org_log from '../../assets/img/logo/no_gl_seal_light.png';
import image_loader from '../../assets/img/loader/small_loader.gif'; // eslint-disable-next-line
import { copiriPortalRequest, getLanguagePackUrl } from '../api/api';
import { config, general } from '../config/config'; // eslint-disable-next-line
import xx from '../../assets/img/pages/xx.webp';
import ModalLoader from '../common/ModalLoader';
import AddSection from './AddSection';
const Main = (props) => {
	const [showSearchDropDown, setShowSearchDropDown] = useState(false);
	const [show, setShow] = useState(false);
	const [organizationResultStatus, setOrganizationResultStatus] = useState('positive');
	const [searchOrgData, setSearchOrgData] = useState([]);
	const [showResult, setShowResult] = useState(false);
	const [searchInputValue, setSearchInputValue] = useState('');
	const [inputError, setInputError] = useState('');
	const [showLoader, setShowLoader] = useState(false);
	const [orgImage, setOrgImage] = useState('');
	const [orgName, setOrgName] = useState('');
	const [pageLanguageContent, setPageLanguageContent] = useState([]); // eslint-disable-next-line
	const [commonLangugaeContent, setCommonLangugaeContent] = useState([]); // eslint-disable-next-line
	const [adsData, setAdsData] = useState([]);
	const [orgModalData, setOrgModalData] = useState([]);
	const [showModalLoader, setShowModalLoader] = useState(false);
	useEffect(() => {
		getLanguagePack();
		getAdsData();
		// eslint-disable-next-line
	}, []);

	/* function to get the translated language text */
	function getLanguagePack() {
		let checkData = JSON.parse(localStorage.getItem('idiom'));
		if (checkData === null || checkData === undefined || checkData === '') {
			// if not store in local storage, call api to get it and store in local storage
			var getLanguageURL = getLanguagePackUrl();
			copiriPortalRequest(getLanguageURL, config.app_version, 'get')
				.then((response) => {
					if (response?.data?.WCS?.AAA) {
						setCommonLangugaeContent(response.data.WCS.AAA);
					}
					if (response?.data?.WCS?.HME) {
						setPageLanguageContent(response.data.WCS.HME);
						localStorage.setItem('idiom', JSON.stringify(response.data.WCS));
					}
				})
				.catch((error) => {});
		} else {
			// if stores in localstorage
			if (checkData?.HME) {
				setPageLanguageContent(checkData?.HME);
			}
			if (checkData?.AAA) {
				setCommonLangugaeContent(checkData.AAA);
			}
		}
	}

	/* function to get the ads data */
	function getAdsData() {
		copiriPortalRequest('/web/wcrmgl/overview/ads', config.app_version, 'get')
			.then((response) => {
				if (response.data.ads && response.data.ads.length > 0) {
					setAdsData(response?.data?.ads);
				} else {
					setAdsData([]);
				}
			})
			.catch((error) => {});
	}

	/* function to close the modal */
	const handleClose = () => setShow(false);

	/* function click on check button*/
	function searchOrganizationData() {
		searchResult(searchInputValue);
	}

	/* function to get input value and search call API for search organizations*/
	const searchOrganization = (event) => {
		setSearchInputValue(event.target.value);
		let searchValue = event.target.value;
		searchResult(searchValue);
	};
	/* function to call api to get search result */
	function searchResult(searchValue) {
		setShowSearchDropDown(false);
		setSearchOrgData([]);
		setShowResult(false);
		setInputError('');
		if (searchValue == '') {
			setInputError(pageLanguageContent['HME011']);
		} else {
			if (searchValue && searchValue!=='') {
				searchValue = searchValue.trim();
				if (searchValue && searchValue.length < 6) {
					setInputError(pageLanguageContent['HME012']);
				} else {
					setShowLoader(true);
					copiriPortalRequest('/web/wcrmgl/search?input=' + searchValue, config.app_version, 'post')
						.then((response) => {
							setShowLoader(false);
							setShowSearchDropDown(true);
							setShowResult(true);
							if (response.data.length > 0) {
								setSearchOrgData(response.data);
							} else {
								setSearchOrgData([]);
							}
						})
						.catch((error) => {
							setShowLoader(false);
							setShowSearchDropDown(true);
							setShowResult(true);
							console.error(error);
						});
				}
			}

			
		}
	}

	/* function to hide the search result dropdown */
	function hideDropDownResult() {
		setShowSearchDropDown(false);
		setSearchInputValue('');
	}

	/* function to show search organization modal */
	function showOrganizationalModal(type, image, name, org_uuid) {
		//setOrgModalData
		setShowModalLoader(true);
		setShow(true);
		setOrganizationResultStatus(type);
		setSearchInputValue('');
		setShowSearchDropDown(false);
		if (image) {
			setOrgImage(image);
		} else {
			setOrgImage(org_log);
		}
		setOrgName(name);
		copiriPortalRequest('/web/wcrmgl/status/' + org_uuid, config.app_version, 'get')
			.then((response) => {
				setShowModalLoader(false);
				if (response?.data?.text) {
					setOrgModalData(response?.data);
				} else {
					setOrgModalData([]);
				}
			})
			.catch((error) => {
				setShowModalLoader(false);
			});
	}

	return (
		<>
			<div className='hero-section-2'>
				<div className='container'>
					<div className='row'>
						<div className='col-lg-12'>
							<div className='hero-content-2'>
								<h2>
									<span data-aos='fade-up' data-aos-duration='1000'>
										{pageLanguageContent['HME001'] ? pageLanguageContent['HME001'] : ''}
									</span>
								</h2>
								<p>{pageLanguageContent['HME002'] ? pageLanguageContent['HME002'] : ''}</p>
								<div className='image-generator-box'>
									<div className='searchbox' data-aos='fade-zoom-in' data-aos-duration='1500'>
										<div className='searchwrapper'>
											<div className='row align-items-center'>
												<div className='col-md-9'>
													<input
														type='text'
														className='form-control'
														placeholder={pageLanguageContent['HME003'] ? pageLanguageContent['HME003'] : ''}
														onChange={searchOrganization}
														value={searchInputValue}
													/>
												</div>
												<div className='col-lg-3'>
													<form>
														<button className='btn' type='button' onClick={() => searchOrganizationData()}>
															{pageLanguageContent['HME004'] ? pageLanguageContent['HME004'] : ''}
															{showLoader && (
																<img className='image_loader' src={image_loader} alt='loader' height='20' width='20' />
															)}
														</button>
													</form>
												</div>
											</div>
										</div>
									</div>
									{inputError && (
										<p className='text-start' style={{ position: 'absolute' }}>
											{inputError}
										</p>
									)}
									{showSearchDropDown && (
										<div className='organizationSearchDropDown align-item-center'>
											<h6>{pageLanguageContent['HME005'] ? pageLanguageContent['HME005'] : ''}</h6>
											<span className='closeDropDown' role='button' onClick={() => hideDropDownResult()}>
												<i className='fas fa-times'></i>
											</span>
											<hr />
											{searchOrgData.length > 0 && // eslint-disable-next-line
												searchOrgData.map((item, i) => (
													<div
														className='align-item-center media mt-3'
														onClick={() => showOrganizationalModal('positive', item?.icon, item?.name, item?.uuid)}
														role='button'
														key={item?.uuid}
													>
														<div className='avatar avatar-l rounded-circle '>
															{item.icon ? (
																<img
																	className='rounded-circle searchOrgImage'
																	src={item?.icon}
																	alt=''
																	onError={(e) => (e.target.src = org_log)}
																/>
															) : (
																<img
																	className='rounded-circle searchOrgImage'
																	src={org_log}
																	alt=''
																	onError={(e) => (e.target.src = org_log)}
																/>
															)}
														</div>
														<div className='ms-2 media-body'>
															<p className='mb-0'>{item?.name}</p>
														</div>
													</div>
												))}
											{searchOrgData.length <= 0 && showResult && (
												<div className='align-item-center media mt-2'>
													<h6 tabIndex='-1' className='px-card pt-0 pb-2 dropdown-header'>
														{pageLanguageContent['HME006'] ? pageLanguageContent['HME006'] : ''}
													</h6>
												</div>
											)}
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<AddSection adsData={adsData} commonLangugaeContent={commonLangugaeContent}/>			
			<div className='portfolio-details ptb-10'></div>
			<Modal
				show={show}
				onHide={handleClose}
				id='searchOrganizationModal'
				className={'' + organizationResultStatus}
				data-bs-theme='dark'
				centered
				size={'lg'}
			>
				{showModalLoader ? (
					<ModalLoader />
				) : (
					<Modal.Body closeButton>
						<div className='row align-items-center'>
							<div className='col-lg-12'>
								<div className='align-items-center mb-2 media'>
									<img
										className='rounded-circle resultOrgImage'
										src={orgImage}
										alt=''
										width='100'
										onError={(e) => (e.target.src = org_log)}
									/>
									<div className='ms-3 media-body'>
										<h4> {orgName} </h4>
									</div>
								</div>
							</div>
						</div>
						<div className='row align-items-center'>
							<div className='col-lg-12'>
								<p className='mt-4'>
									<i className={`fas fa-${orgModalData?.icon}`} style={{ color: orgModalData?.color }}></i>
									<span className='ms-1'>{orgModalData?.title}</span>
								</p>
								<p>
									<small className='small_text'>{orgModalData?.text}</small>
								</p>
							</div>
						</div>
						<div className='row align-items-center mt-4'>
							<div className='col-lg-12'>
								<Link to='/details' className={`nav-link`}>
									<p className='footer_text'>
										<small>{pageLanguageContent['HME010'] ? pageLanguageContent['HME010'] : ''}</small>
									</p>
								</Link>
							</div>
						</div>

						<div className='row mt-3'>
							<Link
								to={pageLanguageContent['HME009'] ? pageLanguageContent['HME009'] : ''}
								className={`col-lg-12`}
								target='_blank'
							>
								<div className=''>
									<div className='mb-2 media'>
										<img
											className=''
											src={'https://amity.copiri.com/img/amity_white.png'}
											alt=''
											width='75'
											onError={(e) => (e.target.src = org_log)}
										/>
										<div className='ms-2 media-body'>
											<p className='footer_text'>
												<small>{pageLanguageContent['HME008'] ? pageLanguageContent['HME008'] : ''}</small>
											</p>
										</div>
									</div>
								</div>
							</Link>
						</div>
					</Modal.Body>
				)}
			</Modal>
		</>
	);
};

export default Main;
